import { useCallback } from 'react'
import { debounce } from 'lodash'
import { useAppDispatch } from '@/state'

import { UpdateUserPayload, TwoFactorUserPayload } from '@/state/user/models'
import { GetBrandsPayload } from '@/state/brands/models'

import { getAllBrandsThunk } from '@/state/brands/thunks/get-all.thunk'
import { getSecretCodesThunk } from '@/state/user/thunks/get-code.thunk'
import { getBackupCodesThunk } from '@/state/user/thunks/get-backup-codes.thunk'

import { createBackupCodesThunk } from '@/state/user/thunks/create-backup-codes.thunk'
import { updateUserThunk } from '@/state/user/thunks/update.thunk'

const useActions = () => {
  const dispatch = useAppDispatch()

  const updateUser = useCallback(
    (payload: UpdateUserPayload) => dispatch(updateUserThunk(payload)),
    [dispatch],
  )

  const getAllBrands = debounce(
    (payload: GetBrandsPayload) => {
      dispatch(getAllBrandsThunk(payload))
    },
    500, // eslint-disable-line
  )

  const getSecretCode = (payload: TwoFactorUserPayload) => {
    dispatch(getSecretCodesThunk(payload))
  }

  const getBackupCodes = (payload: TwoFactorUserPayload) => {
    dispatch(getBackupCodesThunk(payload))
  }

  const createBackupCodes = (payload: TwoFactorUserPayload) => {
    dispatch(createBackupCodesThunk(payload))
  }

  return {
    updateUser,
    getAllBrands,
    getSecretCode,
    getBackupCodes,
    createBackupCodes,
  }
}

export default useActions
